import React, {useContext} from 'react'
import classnames from 'classnames'

import {Button, Icon, Link, Text} from '../../../ui/components'
import {Context} from '../../Context'
import {THeaderBlockItem} from '../../types'

import styles from './styles.module.css'

type TLinkListItemProps = {
  item: THeaderBlockItem
  className?: string
}

export function LinkListItem({item, className}: TLinkListItemProps) {
  const {reachGoal} = useContext(Context)

  return (
    <Link
      href={item.link}
      underline={false}
      onClick={() => item?.goal && reachGoal?.(item.goal)}
      className={classnames(styles.linkListItem, {[styles.mobile]: item.mobileOnly}, className)}
    >
      {item.icon && <Icon name={item.icon} size={item.iconSize} className={styles.linkListIcon} />}
      <div>
        <div className={styles.linkListTitle}>
          <Text tag="p" kind="body" color="controlBlack">
            {item.text}
          </Text>
          {item.badge && <span className={styles.linkListItemBadge}>{item.badge}</span>}
        </div>
        {item.caption && (
          <Text tag="p" kind="caption" color="textGrey" className={styles.caption}>
            {item.caption}
          </Text>
        )}
      </div>

      <div className={styles.linkListItemRightIcon}>
        {item?.linkButton ? (
          <Button variant="navigation" className={styles.linkButton}>
            {item.linkButton}
          </Button>
        ) : (
          <Icon name="chevron" size="m" className={styles.linkListItemChevron} />
        )}
      </div>
    </Link>
  )
}
